"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QTPager = void 0;
var react_1 = __importStar(require("react"));
var lodash_1 = __importDefault(require("lodash"));
require("./index.less");
var huaxiang_stat_1 = require("../../modules/huaxiang_stat");
var url_1 = require("../../modules/url");
var cookie_1 = __importDefault(require("../../modules/cookie"));
var zwhd_1 = require("../zwhd");
// export function QTPager(){
//   return (
//   <div className="qtpager">
//     <span className="disabled">上一页</span>
//     <a href="">1</a>
//     <a href="">2</a>
//     <a href="">3</a>
//     <span className="dot">...</span>
//     <a href="">16</a>
//     <a href="">下一页</a>
//     <form action="">
//       转到 
//       <input type="text" />
//       <input type="submit" value="GO" />
//     </form>
//   </div>
//   )
// }
function QTPager(props) {
    var _a = (0, react_1.useState)(props.nowindex), nowindex = _a[0], setNowIndex = _a[1];
    /**
     * 总页数
     */
    var maxpage = Math.ceil(props.count / props.pagesize);
    (0, react_1.useEffect)(function () {
        setNowIndex(props.nowindex);
    }, [props.count, props.nowindex]);
    (0, react_1.useEffect)(function () {
        //判断gopage search参数
        var gopage = (0, url_1.getQueryParams)('gopage');
        if (gopage && parseInt(gopage) > 0 && parseInt(gopage) <= maxpage) {
            // let selfl = self.location
            // //移除gopage参数 只改url不跳转
            // selfl.search = selfl.search.replace(/&?gopage=\d+/, '')
            // if(selfl.search == '?'){
            //   selfl.search = ''
            // }      
            setNowIndex(parseInt(gopage));
            props.onChangePager(parseInt(gopage));
            var tourl = location.href.replace(/&?gopage=\d+/, '');
            history.replaceState({}, "", tourl);
        }
    }, []);
    (0, react_1.useEffect)(function () {
        var reloaden = function (event) {
            if (event.persisted) {
                if (cookie_1.default.get('uidal')) {
                }
                else {
                    // 从 bfcache 恢复，通常是后退/前进操作
                    // console.log('页面从缓存恢复（可能是后退回来）');
                    // 这里可以刷新数据或重置状态
                    location.reload(); // 如需强制刷新          
                }
            }
        };
        window.addEventListener('pageshow', reloaden);
        return function () {
            window.removeEventListener('pageshow', reloaden);
        };
    }, []);
    /**
     * 页码数组
     */
    var fylist = [];
    var numberlist = [];
    numberlist.push(1);
    for (var index = nowindex - 2; index <= nowindex + 2; index++) {
        numberlist.push(index);
    }
    numberlist.push(maxpage);
    numberlist.sort(function (v1, v2) {
        return v1 - v2;
    });
    numberlist = numberlist.filter(function (v) { return v > 0 && v <= maxpage; });
    numberlist = lodash_1.default.uniq(numberlist);
    fylist = numberlist.map(function (v) {
        return {
            text: v,
            num: v,
            active: v == nowindex,
            title: ''
        };
    });
    if (numberlist[1] - numberlist[0] > 1) {
        fylist.splice(1, 0, {
            text: '...',
            num: nowindex,
            active: false,
            title: ''
        });
    }
    if (numberlist[numberlist.length - 1] - numberlist[numberlist.length - 2] > 1) {
        fylist.splice(fylist.length - 1, 0, {
            text: '...',
            num: nowindex,
            active: false,
            title: ''
        });
    }
    if (nowindex > 1) {
        fylist.unshift({
            text: '<',
            num: nowindex - 1,
            active: false,
            title: '上一页'
        });
    }
    if (nowindex < maxpage) {
        fylist.push({
            text: '>',
            num: nowindex + 1,
            active: false,
            title: '下一页'
        });
    }
    var changePager = function (gonum, e) {
        //未登录用户限制  列表页只给前30页和后10页
        if ((0, zwhd_1.fingerprintValid)() && (0, url_1.getQueryParams)('env') == null) {
            if (!cookie_1.default.get('uidal')) {
                if (gonum > 30 && gonum < maxpage - 9) {
                    var selfl = self.location;
                    //在当前url上增加search参数gopage
                    var searcho = new URLSearchParams(selfl.search);
                    searcho.set('gopage', gonum.toString());
                    var backurl_1 = selfl.origin + selfl.pathname + '?' + searcho.toString() + selfl.hash;
                    // console.info(backurl)
                    // let backurl = self.location.href
                    (0, huaxiang_stat_1.sendJumpLogin)();
                    setTimeout(function () {
                        self.location.href = "https://passport2.eastmoney.com/pub/login?backurl=".concat(encodeURIComponent(backurl_1));
                    }, 100);
                    // return
                }
            }
        }
        //统计
        //console.info(gonum, location.hash)
        if (location.pathname.toLowerCase() == '/center/gridlist.html') {
            (0, huaxiang_stat_1.sendHuaXiangStat_ListIndex)(location.hash, gonum.toString());
        }
        e === null || e === void 0 ? void 0 : e.preventDefault();
        setNowIndex(gonum);
        props.onChangePager(gonum);
    };
    var inputEl = (0, react_1.useRef)(null);
    var gotoSubmit = function () {
        var thisinput = inputEl.current;
        var value = thisinput.value;
        var goto = Number(value);
        if (isNaN(goto)) {
            changePager(1);
        }
        else if (goto > maxpage) {
            changePager(maxpage);
        }
        else if (goto < 1) {
            changePager(1);
        }
        else {
            changePager(goto);
        }
        thisinput.value = '';
        thisinput.blur();
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, maxpage > 1 &&
        react_1.default.createElement("div", { className: "qtpager" },
            fylist.map(function (v, index) {
                return react_1.default.createElement(react_1.default.Fragment, { key: index }, v.text == '...' ?
                    react_1.default.createElement("span", { className: "dot" }, "\u2026")
                    :
                        react_1.default.createElement("a", { href: "#", "data-pi": "2", className: v.active ? 'acitve' : '', onClick: function (e) { changePager(v.num, e); }, title: v.title }, v.text));
            }),
            react_1.default.createElement("form", { className: "gotoform", onSubmit: function (e) { e.preventDefault(); gotoSubmit(); } },
                "\u8F6C\u5230",
                react_1.default.createElement("input", { type: "text", ref: inputEl }),
                react_1.default.createElement("input", { type: "submit", value: "GO" })))));
}
exports.QTPager = QTPager;
